import { Outlet } from 'react-router-dom'
import styled from 'styled-components'

const SimplePageLayout = () => (
  <Wrapper>
    <Outlet />
  </Wrapper>
)

const Wrapper = styled.div`
  max-width: 1080px;
  padding-bottom: 50px;
  margin-left: auto;
  margin-right: auto;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    padding-right: 0;
  }
`

export default SimplePageLayout
